<div id="alloyWebSdk" style="height: 100vh; width: 100vw; background: white;">
  <div id="document-capture-dialog"></div>
</div>
